import { DevicesList, Doctor } from '../interfaces'
import {
  PATIENT_DATA_LOADED,
  PATIENT_DOB,
  PATIENT_FHIR_ID,
  PATIENT_GENDER,
  PATIENT_NAME,
  PATIENT_UHID,
  PATIENT_BED_NUMBER,
  PATIENT_ROOM_NUMBER,
  PATIENT_WARD_NAME,
  LAYOUT,
  BED_ID,
  BED_NUMBER,
  ADMISSION_DATE,
  SELECTED_PATIENT_INDEX,
  MASTER_PATIENT_DETAILS,
  CURRENT_LOCATION,
  SELECTED_DEVICE_INDEX,
  IS_DEVICE_CLICKED,
  LOCATIONS_LIST,
  ONLY_LOCATIONS,
  SEARCH_QUERY,
  THOP_NOTIFICATION_MESSAGES_ADD,
  THOP_NOTIFICATION_MESSAGES_DELETE,
  DOCTORS_LIST,
  STATUS_UPDATE_COUNT, // count to update the status of medication when accepted or rejected from thop
  SELECTED_DEVICE,
  DEVICE_LIST, // list of all the devices
  IPD_UPDATE_COUNT, // count which updates when a new patient is added or discharged from thop ipd
  IPD_UPDATE_MESSAGE_LOCATION,
  IPD_DATA_UPDATE_COUNT, // count to update the data according to the patient muh Id on thop socket Message
  IPD_UPDATE_MESSAGE, // ipd Socket message which we get from thopNotification Socket
  SELECTED_CATEGORY,
  PRORITHM_NOTIFICATIONS_ADD,
  PRORITHM_NOTIFICATIONS_REMOVE,
  PRORITHM_NOTIFICATIONS_MARK_READ,
  PRORITHM_WEBSOCKET_MESSAGE,
  PRORITHM_WEBSOCKET_COUNT,
  PRORITHM_WEBSOCKET_CONNECTION_STATUS,
} from './actions'

interface PatientState {
  patient_data_loaded: boolean
  patient_name: string
  patient_uhid: string
  patient_dob: string
  patient_fhir_id: string
  patient_gender: string
  patient_bed_number: string
  patient_room_number: string
  patient_ward_name: string
  selectedPatientIndex: number | null
  selectedDeviceIndex: number | null
  searchQuery: string
  layout: string
  bedId: string
  bedNumber: string
  admissionDate: string
  masterPatientDetails: any[]
  currentLocation: string
  ipdUpdateMessageLocation: string
  isDeviceClicked: boolean
  locationsList: any[]
  onlyLocations: string[]
  doctorsList: Doctor[]
  thopNotificationMessages: any[]
  statusUpdateCount: number
  ipdRegistrationFlagCount: number
  ipdDataUpdateCount: number
  selectedDevice: DevicesList | null
  deviceList: DevicesList[]
  newIpdUpdateMessage: IpdUpdateMessage
  selectedCategory: string
  prorithmWebSocketConnectionStatus: boolean
  prorithmNotifications: any[]
  prorithmWebSocketMessage: any
  prorithmWebSocketCount: number
}

interface IpdUpdateMessage {
  message: string
  patientLocation: string
  messageType: string
  patientID: string
}

interface Action {
  type: string
  payload?: any
}

const initialState: PatientState = {
  patient_data_loaded: false,
  patient_name: '',
  patient_uhid: '',
  patient_dob: '',
  patient_fhir_id: '',
  patient_gender: '',
  patient_bed_number: '',
  patient_room_number: '',
  patient_ward_name: '',
  selectedPatientIndex: null,
  selectedDeviceIndex: null,
  searchQuery: '',
  layout: 'none',
  bedId: '',
  bedNumber: '',
  admissionDate: '',
  masterPatientDetails: [],
  currentLocation: process.env.REACT_APP_AMALAPURAM_TEXT ?? '',
  ipdUpdateMessageLocation: '',
  isDeviceClicked: false,
  locationsList: [],
  onlyLocations: [],
  doctorsList: [],
  thopNotificationMessages: [],
  statusUpdateCount: 0,
  ipdRegistrationFlagCount: 0,
  ipdDataUpdateCount: 0,
  selectedDevice: null,
  deviceList: [],
  newIpdUpdateMessage: {
    message: '',
    patientLocation: '',
    messageType: '',
    patientID: '',
  },
  selectedCategory: process.env.REACT_APP_AMBULANCE_TEXT ?? '',
  prorithmWebSocketConnectionStatus: false,
  prorithmNotifications: [],
  prorithmWebSocketMessage: null,
  prorithmWebSocketCount: 0,
}

export const loadingActionReducer = (
  state: PatientState = initialState,
  action: Action
): PatientState => {
  switch (action?.type) {
    case PATIENT_DATA_LOADED:
      return {
        ...state,
        patient_data_loaded: action?.payload,
      }

    case PATIENT_NAME:
      return {
        ...state,
        patient_name: action?.payload,
      }

    case PATIENT_UHID:
      return {
        ...state,
        patient_uhid: action?.payload,
      }

    case PATIENT_DOB:
      return {
        ...state,
        patient_dob: action?.payload,
      }

    case PATIENT_GENDER:
      return {
        ...state,
        patient_gender: action?.payload,
      }

    case PATIENT_FHIR_ID:
      return {
        ...state,
        patient_fhir_id: action?.payload,
      }

    case PATIENT_BED_NUMBER:
      return {
        ...state,
        patient_bed_number: action?.payload,
      }

    case PATIENT_ROOM_NUMBER:
      return {
        ...state,
        patient_room_number: action?.payload,
      }

    case PATIENT_WARD_NAME:
      return {
        ...state,
        patient_ward_name: action?.payload,
      }

    case SELECTED_PATIENT_INDEX:
      return {
        ...state,
        selectedPatientIndex: action?.payload,
      }

    case SELECTED_DEVICE_INDEX:
      return {
        ...state,
        selectedDeviceIndex: action?.payload,
      }

    case LAYOUT:
      return {
        ...state,
        layout: action?.payload,
      }

    case BED_ID:
      return {
        ...state,
        bedId: action?.payload,
      }

    case BED_NUMBER:
      return {
        ...state,
        bedNumber: action?.payload,
      }

    case ADMISSION_DATE:
      return {
        ...state,
        admissionDate: action?.payload,
      }

    case MASTER_PATIENT_DETAILS:
      return {
        ...state,
        masterPatientDetails: [...state.masterPatientDetails, action?.payload],
      }

    case CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action?.payload,
      }

    case IPD_UPDATE_MESSAGE_LOCATION:
      return {
        ...state,
        ipdUpdateMessageLocation: action?.payload,
      }

    case IS_DEVICE_CLICKED:
      return {
        ...state,
        isDeviceClicked: action?.payload,
      }

    case LOCATIONS_LIST:
      return {
        ...state,
        locationsList: action?.payload,
      }

    case ONLY_LOCATIONS:
      return {
        ...state,
        onlyLocations: action?.payload,
      }

    case SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action?.payload,
      }

    case DOCTORS_LIST:
      return {
        ...state,
        doctorsList: action?.payload,
      }

    case THOP_NOTIFICATION_MESSAGES_ADD:
      return {
        ...state,
        thopNotificationMessages: [
          ...state.thopNotificationMessages,
          action?.payload,
        ],
      }

    case THOP_NOTIFICATION_MESSAGES_DELETE:
      return {
        ...state,
        thopNotificationMessages: state.thopNotificationMessages?.filter(
          (_: any, index: number) => index !== action?.payload
        ),
      }

    case STATUS_UPDATE_COUNT:
      return {
        ...state,
        statusUpdateCount: state.statusUpdateCount + 1,
      }

    case IPD_UPDATE_COUNT:
      return {
        ...state,
        ipdRegistrationFlagCount: state.ipdRegistrationFlagCount + 1,
      }

    case IPD_DATA_UPDATE_COUNT:
      return {
        ...state,
        ipdDataUpdateCount: state.ipdDataUpdateCount + 1,
      }

    case SELECTED_DEVICE:
      return {
        ...state,
        selectedDevice: action?.payload,
      }

    case DEVICE_LIST:
      return {
        ...state,
        deviceList: action?.payload,
      }

    case IPD_UPDATE_MESSAGE:
      return {
        ...state,
        newIpdUpdateMessage: action?.payload,
      }

    case SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action?.payload,
      }

    case PRORITHM_NOTIFICATIONS_ADD:
      return {
        ...state,
        prorithmNotifications: [
          ...state.prorithmNotifications,
          action?.payload,
        ],
      }

    case PRORITHM_NOTIFICATIONS_REMOVE:
      return {
        ...state,
        prorithmNotifications: state.prorithmNotifications?.filter(
          (_: any, index: number) => index !== action?.payload
        ),
      }

    case PRORITHM_NOTIFICATIONS_MARK_READ:
      return {
        ...state,
        prorithmNotifications: state.prorithmNotifications?.map(
          (notification, index) =>
            index === action?.payload
              ? { ...notification, isRead: true }
              : notification
        ),
      }
    case PRORITHM_WEBSOCKET_MESSAGE:
      return { ...state, prorithmWebSocketMessage: action?.payload }

    case PRORITHM_WEBSOCKET_COUNT:
      return {
        ...state,
        prorithmWebSocketCount: state.prorithmWebSocketCount + 1,
      }

    case PRORITHM_WEBSOCKET_CONNECTION_STATUS:
      return { ...state, prorithmWebSocketConnectionStatus: action?.payload }

    default:
      return state
  }
}
